import { render, staticRenderFns } from "./SectionSubtitle.vue?vue&type=template&id=7b0e8a32&scoped=true&"
var script = {}
import style0 from "./SectionSubtitle.vue?vue&type=style&index=0&id=7b0e8a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0e8a32",
  null
  
)

export default component.exports